import { render, staticRenderFns } from "./Anzan.vue?vue&type=template&id=710f533c&scoped=true&lang=pug&"
import script from "./Anzan.vue?vue&type=script&lang=js&"
export * from "./Anzan.vue?vue&type=script&lang=js&"
import style0 from "./Anzan.vue?vue&type=style&index=0&id=710f533c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710f533c",
  null
  
)

export default component.exports